import { render, staticRenderFns } from "./ModalHead.vue?vue&type=template&id=3425eb83&scoped=true&"
import script from "./ModalHead.vue?vue&type=script&lang=js&"
export * from "./ModalHead.vue?vue&type=script&lang=js&"
import style0 from "./ModalHead.vue?vue&type=style&index=0&id=3425eb83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425eb83",
  null
  
)

export default component.exports